<div class="" *ngIf="getIdComponentByCode('PARTICULAR_HOME_PAGE_COMPONENT')">
  <app-banner [componentId]="'PARTICULAR_HEADING_BANNER'"></app-banner>
  <app-html [componentId]="getIdComponentByCode('PARTICULAR_HOME_PAGE_COMPONENT')"></app-html>
  <div class="btn-box text-center mb-5">
    <a class="default-primary-btn" [routerLink]="contactUsPageUrl$ | async"
      ><span class="label">{{ 'CONTACT_US' | translate }}</span></a
    >
  </div>
</div>
